
<div>
  <!--Side-bar-->
  <app-side-bar *ngIf="showSideBar" [sections]="this.sections"></app-side-bar>

  <!--Top menu -->
  <ng-container *ngIf="this.company">
    <app-top-menu></app-top-menu>
  </ng-container>
  

  <!--Div que é mostrada no modo tablet/celular para quando a pessoa descer to topo da pagina-->
  <app-top-header (showInput)="this.showInput = $event"></app-top-header>

  <!--Categorias no menu superior-->
  <app-top-bar [sections]="this.sections" [tabela]="this.tabela" [verifiScrolling]="this.verifiScrolling"></app-top-bar>

  <!--Banners-->
  <!-- <app-banners></app-banners> -->

  <!--Menu inteiro-->
  <div #menu>
    <div class="page-wrapper" [ngClass]="{'isMobile': this.isMobile, 'isTablet': this.isTablet, 'isDesktop': this.isDesktop, 'local': this.local, 'readOnly': this.readOnlyState}">
      <div class="menu">
        <!--Lista de Categorias, para listar os produtos-->
        <div class="lista-category">

          <!--Primeira Lista-->
          <ng-container *ngFor="let category of tabela; let last = last; let indexSection = index" >
            <ng-container *ngIf="(category.products | filtro: filter : 'name').length > 0">

              <section class="painel" [id]="category.categoryName" [ngStyle]="{'margin-bottom.px': last ? 0 : 40}" #sections>

                <div class="title-painel">
                  <h2 style="margin-bottom: 0px;">{{ category.categoryName }}</h2>
                </div>

                <div class="body-painel">
                  <div class="products">
                    <ng-container *ngFor="let product of category.products | filtro: this.filter: 'name'; let index = index">
                      <app-product-menu class="product-card" [product]="product" [indexSection]="indexSection" [typeParam]="this.typeParam"></app-product-menu>
                    </ng-container>
                  </div>
                </div>

              </section>

            </ng-container>

          </ng-container>

          <!--Se nenhum produto for encontrado-->
          <ng-container *ngIf="emptyProduct">
            <div class="message-not-found">
              <span style="color: gray">Nenhum Produto encontrado</span>
            </div>
          </ng-container>

          <!--Logo Final da lista-->
          <div class="WariningPowered">
            <div style="position: relative; top: 17px; left: 0px;">
              <span style=" color: #652969; font-size: 13px;">from</span>
            </div>
            <div>
              <img src="assets/logo/logo-qrcode-pedeaqui.png" style="width: 32px;"/><img src="assets/logo/logo-name-pedeaqui.png" style="width: 100px;"/>
            </div>
            <div *ngIf="this.versionApp != ''" style="text-align: center; color: gray; font-size: 13px;">Versão {{ this.versionApp }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>